export var SortDirection;
(function (SortDirection) {
    SortDirection["Descending"] = "DESC";
    SortDirection["Ascending"] = "ASC";
    SortDirection["Initial"] = "Initial";
})(SortDirection || (SortDirection = {}));
export var CrudTableTestSubject;
(function (CrudTableTestSubject) {
    CrudTableTestSubject["TableAddButton"] = "table-add-button";
    CrudTableTestSubject["NextPageButton"] = "next-page-button";
    CrudTableTestSubject["PrevPageButton"] = "prev-page-button";
    CrudTableTestSubject["PaginationPerPageSelector"] = "PaginationPerPageSelector";
    CrudTableTestSubject["TableEmptyState"] = "table-empty-state";
    CrudTableTestSubject["SearchInput"] = "crud-search";
})(CrudTableTestSubject || (CrudTableTestSubject = {}));
//# sourceMappingURL=crud.enum.js.map